import "./form-room-type-selection.scss";
import React, { useLayoutEffect, useEffect } from "react";
import { useCheckbox, useFormContext } from "../../../features/auto-form";
import InputWrapper from "../../../components/inputs/input-wrapper/input-wrapper";
import MultiCard from "../../../components/inputs/multi-card/multi-card";
import { useTranslate } from "../../../features/translation/hooks/use-translation";

const FormRoomTypeSelection = (props) => {
  const { ref, bind } = useCheckbox(props);

  const { register, deregister, updateValidity } = useFormContext();

  const { getTranslatedProps } = useTranslate();

  const { translatedOptions = [] } = getTranslatedProps(props);

  useLayoutEffect(() => {
    if (!props.ignore) {
      // Register as ref in form on mount
      register(props.id || props.name, ref);

      // Deregister as ref in form on unmount
      return () => {
        deregister(props.id || props.name);
      };
    }
  }, []);


  useEffect(() => {
    updateValidity(props.name, bind.error);
  }, [bind.error]);

  return (
    <InputWrapper {...bind} {...props}>
      <div className="container" style={{ margin: "0", padding: "0" }}>
        <div className="row">
          {translatedOptions &&
            translatedOptions.map((option) => (
              <div
                className="col col-12 col-sm-6"
                style={{ marginBottom: "var(--space-4)" }}
                key={option.value}
              >
                <MultiCard
                  {...bind}
                  {...props}
                  {...option}
                  key={`${props.name}.${option.value}`}
                  id={`${props.name}.${option.value}`}
                  selected={bind.values.indexOf(option.value) > -1}
                />
              </div>
            ))}
        </div>
      </div>
    </InputWrapper>
  );
};

export default FormRoomTypeSelection;
